module.exports = __webpack_public_path__ + "img/editor.c92302c6.svg";